import { OrthodonticsForChildrenPage } from "~/components/orthodontics-for-children/OrthodonticsForChildrenPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/orthodontics-for-children")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo(
      "/orthodontics-for-children",
    ),
  component: OrthodonticsForChildrenPage,
});
